var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eMigrate_application"},[_c('img',{attrs:{"src":_vm.item,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }